import { isFullscreen } from './environment';

export function exitFullscreen() {
    if (isFullscreen()) {
        if ('exitFullscreen' in document) {
            return document.exitFullscreen();
        } else if ('webkitExitFullscreen' in document) {
            return document.webkitExitFullscreen();
        } else if ('webkitCancelFullScreen' in document) {
            return document.webkitCancelFullScreen();
        } else if ('mozCancelFullScreen' in document) {
            return document.mozCancelFullScreen();
        } else if ('msExitFullscreen' in document) {
            return document.msExitFullscreen();
        }
    }

    const videoElements = document.getElementsByTagName('video');
    for (let i = 0; i < videoElements.length; i++) {
        const element = videoElements[i];

        if ('webkitExitFullscreen' in element) {
            element.webkitExitFullscreen();
        }
    }
}

export function addFullscreenChangeListener(element, handler) {
    element.addEventListener('fullscreenchange', handler);
    element.addEventListener('webkitfullscreenchange', handler);
    element.addEventListener('mozfullscreenchange', handler);
    element.addEventListener('MSFullscreenChange', handler);
}

export function removeFullscreenChangeListener(element, handler) {
    element.removeEventListener('fullscreenchange', handler);
    element.removeEventListener('webkitfullscreenchange', handler);
    element.removeEventListener('mozfullscreenchange', handler);
    element.removeEventListener('MSFullscreenChange', handler);
}
